import React from 'react';

import { formatPhoneNumber } from 'common/formatters';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';
import SrLink from 'client/components/SrLink/SrLink';

const UPAccountManagerCard = ({
  name,
  position,
  email,
  phone,
  profilePictureUrl,
  linkText,
  linkUrl,
}) => {
  return (
    <SrCard margin="0" maxWidth="375px" padding="24px">
      <SrBox display="flex" flexDirection="column" rowGap="12px">
        <SrText font="greycliff" fontSize="24px" weight="800" display="block">
          Your Account Manager
        </SrText>
        <SrBox display="flex" flexDirection="row">
          <SrBox
            borderRadius="50%"
            width="100px"
            height="100px"
            backgroundImage={`url(${profilePictureUrl})`}
            backgroundSize="cover"
            backgroundPosition="center"
            marginRight="16px"
            flexShrink="0"
          />
          <SrBox display="flex" flexDirection="column" flex="1">
            <SrText font="greycliff" fontSize="16px" weight="800" lineHeight="20px">
              {name}
            </SrText>
            <SrText font="greycliff" fontSize="12px" weight="600" lineHeight="16px" marginTop="2px">
              {position}
            </SrText>
            <SrText font="greycliff" fontSize="16px" lineHeight="20px" weight="600" marginTop="6px">
              {email}
            </SrText>
            <SrText font="greycliff" fontSize="16px" lineHeight="20px" weight="600" marginTop="2px">
              {formatPhoneNumber(phone)}
            </SrText>
            {linkText && linkUrl && (
              <SrLink to={linkUrl} target="_blank" style={{ marginTop: '6px' }}>
                <SrText
                  font="greycliff"
                  fontSize="16px"
                  lineHeight="20px"
                  color="blue300"
                  weight="600"
                  whiteSpace="nowrap"
                >
                  {linkText}
                </SrText>
              </SrLink>
            )}
          </SrBox>
        </SrBox>
      </SrBox>
    </SrCard>
  );
};

export default UPAccountManagerCard;
